// extracted by mini-css-extract-plugin
export default {"root":"static-templates-folder_root__wjNMR","title":"static-templates-folder_title__fZ76j"};